import {useEffect, useState} from 'react';

import {usePostContractualTermAcceptMutation} from '../../../../query/usePostContractualTermAcceptMutation';
import {getContractualTermLink} from '../../../../services/getContractualTermLink';
import {useOdontoTermDrawerStore} from '../../../../store/useOdontoTermDrawerStore';
import {parseContractualTermUrl} from '../../../../utils/parseContractualTermUrl';
import {useOdontoTermDrawerVisibility} from '../useOdontoTermDrawerVisibility';

export function useOdontoTermDrawer() {
	const [isTermAgreed, setIsTermAgreed] = useState(false);
	const [isTermAgreementTouched, setIsTermAgreementTouched] = useState(false);
	const [generalConditionsUrl, setGeneralConditionsUrl] = useState('');

	const {isOpen, contractNumber, planName, ansRegister} = useOdontoTermDrawerVisibility();
	const dismissDrawer = useOdontoTermDrawerStore(state => state.dismissDrawer);

	const {mutate: acceptContractualTerm, isPending: isAcceptingTerm} =
		usePostContractualTermAcceptMutation();

	const hasTermAgreementError = isTermAgreementTouched && !isTermAgreed;

	const {termName, version} = parseContractualTermUrl(generalConditionsUrl);

	useEffect(() => {
		let isCurrent = true;

		if (isOpen && !generalConditionsUrl) {
			getContractualTermLink()
				.then(({url}) => {
					if (isCurrent) setGeneralConditionsUrl(url);
				})
				.catch(() => null);
		}

		return () => {
			isCurrent = false;
		};
	}, [isOpen, generalConditionsUrl]);

	const handleOpenGeneralConditions = () => {
		if (!generalConditionsUrl) return;

		window.open(generalConditionsUrl, '_blank', 'noopener noreferrer');
	};

	const toggleTermAgreement = () => {
		if (isTermAgreementTouched) {
			setIsTermAgreementTouched(false);
		}

		setIsTermAgreed(previousValue => !previousValue);
	};

	const handleClose = () => {
		setIsTermAgreed(false);
		setIsTermAgreementTouched(false);
		dismissDrawer();
	};

	const handleAccept = () => {
		setIsTermAgreementTouched(true);

		if (!isTermAgreed) return;

		acceptContractualTerm({
			nuContrato: contractNumber,
			nmTermo: termName,
			dsVersaoTermo: version,
		});
	};

	return {
		isOpen,
		isTermAgreed,
		hasTermAgreementError,
		isAcceptingTerm,
		generalConditionsUrl,
		termName,
		version,
		planName,
		ansRegister,
		toggleTermAgreement,
		handleOpenGeneralConditions,
		handleClose,
		handleAccept,
	};
}
